const STORAGE_KEY = 'jdp-section-collapse';

export type JdpCollapsibleSection = 'salaryContext' | 'matchBreakdown' | 'location';

export const DEFAULT_JDP_SECTION_EXPANDED: Record<JdpCollapsibleSection, boolean> = {
  salaryContext: true,
  matchBreakdown: true,
  // Closed by default — opening it is what triggers the mapbox-gl chunk load.
  location: false,
};

function mergeRecord(raw: unknown): Record<JdpCollapsibleSection, boolean> {
  const out = { ...DEFAULT_JDP_SECTION_EXPANDED };
  if (!raw || typeof raw !== 'object') return out;
  const o = raw as Record<string, unknown>;
  for (const k of Object.keys(DEFAULT_JDP_SECTION_EXPANDED) as JdpCollapsibleSection[]) {
    if (k in o && typeof o[k] === 'boolean') {
      out[k] = o[k];
    }
  }
  return out;
}

export function loadJdpSectionExpandedFromLocalStorage(): Record<JdpCollapsibleSection, boolean> {
  if (typeof window === 'undefined') return { ...DEFAULT_JDP_SECTION_EXPANDED };
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_JDP_SECTION_EXPANDED };
    return mergeRecord(JSON.parse(raw) as unknown);
  } catch {
    return { ...DEFAULT_JDP_SECTION_EXPANDED };
  }
}

export function saveJdpSectionExpandedToLocalStorage(state: Record<JdpCollapsibleSection, boolean>): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (err) {
    console.warn('[job-detail] Failed to save section collapse state:', err);
  }
}
